'use client';

import clsx from 'clsx';
import VideoPlayer from '@/components/ui/layout/video-player/video-player';
import { useTranslation } from 'react-i18next';
import { JContainer } from '../../ui/layout';

export default function DemoVideoWall({
    locale,
}: Readonly<{ locale: string }>) {
    const { t } = useTranslation('terra1-demo-video-wall');

    const videoList = t('videoList', { returnObjects: true }) as {
        name: string;
        url: string;
        cover: string;
    }[];

    return (
        <div className="flex w-full items-center justify-center px-[28px] sm:px-[40px]">
            <JContainer
                size="md2"
                padding="none"
                className="flex flex-col items-center"
            >
                {/* <div
                    className={clsx(
                        'bg-[linear-gradient(90deg,_#7857ff_8.37%,_#e7a9fd_56.02%)] bg-clip-text text-white',
                        {
                            'j-h4': locale === 'en',
                            'j-h4': locale === 'zh',
                        },
                    )}
                >
                    <span>{t('title.part1')}</span>
                    <span
                        style={{
                            WebkitTextFillColor: 'transparent',
                        }}
                    >
                        {t('title.part2')}
                    </span>
                    <span>{t('title.part3')}</span>
                    <span
                        style={{
                            WebkitTextFillColor: 'transparent',
                        }}
                    >
                        {t('title.part4')}
                    </span>
                </div> */}

                <div className="mt-[32px] grid w-full grid-cols-1 gap-[20px] sm:mt-[80px] sm:grid-cols-3 sm:gap-[40px]">
                    {videoList.map((item, index) => (
                        <div
                            key={item.name}
                            className="relative aspect-video w-full overflow-hidden bg-white"
                        >
                            <VideoPlayer hlsUrl={item.url} cover={item.cover} />
                        </div>
                    ))}
                </div>

                <div
                    className={clsx(
                        'j-h5 mt-[32px] w-full text-left text-white sm:mt-[80px] sm:text-center',
                    )}
                >
                    {t('comment')}
                </div>
            </JContainer>
        </div>
    );
}
